import React, { Fragment, useState, useEffect } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Tooltip,
  Chip,
  IconButton,
  Box,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { getFileIconImage } from "../../../../utils/fileUtils";
import { ArrowForwardIosRounded, GridOnRounded } from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";
import { getFile } from "../../../../core/repo/fileRepo";
import Loader from "../../../../components/Loader";

const useStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
  },
  icon: {
    margin: "0px 5px 0px -6px !important",
  },
  card: {
    // boxShadow: "0px 0px 4px 1.194px rgba(0, 0, 0, 0.12)",
    border: `1px solid ${theme.palette.divider}`,
    // background: "white",
    borderRadius: 12,
    margin: "16px 2px 2px 2px",
    // display: "inline-block",
  },
  activeCard: {
    border: `1px solid ${theme.palette.accent}`,
    background: theme.palette.paper,
  },
}));

function Source({ source, answer, handleSourceChange }) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchFile = async () => {
    try {
      const file = await dispatch(getFile(file_id));
      setFile(file);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (file_id) fetchFile();
  }, [file_id]);

  const citations = answer["content_object"]["citations"] || [];

  if (citations.length === 0) {
    return null;
  }

  const citation = citations[0];
  const { section, file_id } = citation;
  const tabularData = JSON.parse(answer["content_object"]["text"]);

  const handleClickSource = () => {
    handleSourceChange({
      ...citation,
      csv_file_map: { [tabularData["sheet"]]: tabularData["csv_file_path"] },
      selected_row_ids: tabularData["selected_row_ids"],
      columns: tabularData["columns"],
      created_at: answer["created_at"],
      jsonQueryObject: tabularData["json_query_object"],
    });
  };

  const isSelected = source && source["created_at"] === answer["created_at"];

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Card
          className={`${classes.card} ${
            isSelected ? classes.activeCard : null
          }`}
          elevation={1}
          onClick={() => handleClickSource()}>
          <CardActionArea>
            <CardContent
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
              <Box
                display={"flex"}
                alignItems={"center"}
                mr={1.5}
                width={"calc(100% - 36px)"}>
                <IconButton sx={{ background: " rgba(14, 157, 88, 0.08)" }}>
                  <GridOnRounded sx={{ color: "#0E9D58" }} />
                </IconButton>
                <Box ml={1} width={"calc(100% - 48px)"}>
                  <Typography fontWeight={500} variant="body2" noWrap>
                    {section}
                  </Typography>
                  <Box mb={1.5} />
                  {file && (
                    <Tooltip title={tabularData["sheet"]}>
                      <Chip
                        label={
                          <Typography variant="caption" noWrap>
                            {tabularData["sheet"]}
                          </Typography>
                        }
                        size="small"
                        icon={
                          <img
                            src={getFileIconImage(file["file_type"])}
                            alt={file["name"]}
                            width={16}
                            height={16}
                          />
                        }
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>
              <IconButton size="small">
                <ArrowForwardIosRounded fontSize="small" />
              </IconButton>
            </CardContent>
          </CardActionArea>
        </Card>
      )}
    </Fragment>
  );
}

export default Source;
